import { render, staticRenderFns } from "./StarshopAccountingDetail.vue?vue&type=template&id=77bea874&scoped=true"
import script from "./StarshopAccountingDetail.vue?vue&type=script&lang=js"
export * from "./StarshopAccountingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bea874",
  null
  
)

export default component.exports